<template>
  <tr @dblclick="$refs['actions'].callFirstStarredAction();"
    class="d-block d-lg-table-row bg-white px-2 py-2 mb-2 border p-lg-0 mb-lg-0 border-lg-0">
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('User') }}</span>
      <div v-if="loginLog.externalUser">
        <FieldReadonly
        :value="loginLog.externalUser ? loginLog.externalUser.first_name + ' ' + loginLog.externalUser.last_name : ''" />
        <FieldReadonly :value="loginLog.externalUser ? loginLog.externalUser.origin_identifier : ''" />
      </div>
      <div v-else>
        <FieldReadonly :value="loginLog.form_username" />
      </div>
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Result') }}</span>
      <FieldReadonly :value="loginLog.loginResult ? loginLog.loginResult.name : ''" />
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Created At') }}</span>
      <FieldReadonly :value="loginLog.created_at" format="datetime" />
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Application') }}</span>
      <FieldReadonly :value="loginLog.application ? loginLog.application.name : i18n('Token')" />
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('IP') }}</span>
      <FieldReadonly :value="loginLog.ip" />
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Access origin') }}</span>
      <FieldReadonly :value="loginLog.is_check_code ? i18n('Token') : i18n('Form')" />
    </td>
    <td data-no-export class="d-block d-lg-table-cell text-end border-0 border-lg-bottom" @click.stop>
      <ActionDropdown ref="actions" :actions="actions" />
    </td>
  </tr>
</template>

<script>
import FieldReadonly from "@/components/common/form/FieldReadonly.vue";
import Field from "@/components/common/form/Field.vue";
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";

export default {
  components: {
    FieldReadonly,
    Field,
    ActionDropdown,
  },
  props: {
    loginLog: Object,
  },
  data() {
    return {};
  },
  emits: [
    'deleted',
    'updating',
    'updated',
  ],
  methods: {
  },
  computed: {
    actions() {
      return [{
        label: this.i18n('Detail'),
        fn: () => {
          this.$router.push({ name: 'loginLog', params: { id: this.loginLog.id } });
        },
        if: false,
        starred: true,
      },
      ];
    },
  },
};
</script>